import { Select } from "antd";
import React, { useEffect } from "react";


function SearchOption({ value, setValue }) {
  const organizerOptions = [
    { value: "Prescription Call", label: " Prescription Call" },
    { value: "Week #1", label: "Week #1" },
    { value: "Week #2", label: "Week #2" },
    { value: "Week #3", label: "Week #3" },
    { label: "Retention", value: "retention" },
    { value: "SPE", label: "SPE" },
    { value: "SLOT_BOOKING", label: "SLOT BOOKING" },
    { value: "IVR_BOOKING", label: "IVR BOOKING" },
    { value: "Feedback Call", label: "Feedback Call" },
    { label: "Slot Booking Total", value: "SLOT_BOOKING_TOTAL" },
    { label: "Abandon Cart", value: "abandoned_cart" },
    { label: "W0_Call", value: "w0_call" },
    { label: "Slot Booking Lead", value: "Lead" },
  ];

  return (
    <div className="" style={{ height: "0.2rem", width: "15rem" }}>
      <Select
        allowClear
        options={organizerOptions}
        placeholder="Filter Tag"
        onChange={(selectedRowKeys) => {
          setValue(selectedRowKeys);
        }}
        style={{ width: "14rem"}}
      />
    </div>
  );
}

export default SearchOption;
